import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import URLS from "redux/urls";
import request from "redux/utils/request";

export const fetchAllMenuType = createAsyncThunk(
  "MenuType/fetchAllMenuType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.MENU_TYPE);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addMenuType = createAsyncThunk(
  "MenuType/addMenuType",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request("post", URLS.MENU_TYPE, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateMenuType = createAsyncThunk(
  "MenuType/updateMenuType",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request(
        "patch",
        `${URLS.MENU_TYPE}/${payload.id}`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchOneMenuType = createAsyncThunk(
  "MenuType/fetchOneMenuType",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.MenuType}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteMenuType = createAsyncThunk(
  "MenuType/deleteMenuType",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.MENU_TYPE}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loading: {
    query: false,
    mutation: false,
  },
  filter: {
    q: "",
  },
  list: [],
  selected: {},
  selectedRows: [],
};

const loadingReducer = (fieldName, status) => (state) => {
  state.loading[fieldName] = status;
};

const startLoadingQuery = loadingReducer("query", true);
const stopLoadingQuery = loadingReducer("query", false);
const startLoadingMutation = loadingReducer("mutation", true);
const stopLoadingMutation = loadingReducer("mutation", false);

export const MenuTypeSlice = createSlice({
  name: "MenuType",
  initialState,
  reducers: {
    setAppliedSearchText: (state, action) => {
      state.filter.q = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllMenuType.pending, startLoadingQuery)
      .addCase(fetchAllMenuType.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllMenuType.rejected, stopLoadingQuery);
    builder
      .addCase(fetchOneMenuType.pending, startLoadingQuery)
      .addCase(fetchOneMenuType.rejected, stopLoadingQuery)
      .addCase(fetchOneMenuType.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(updateMenuType.pending, startLoadingQuery)
      .addCase(updateMenuType.rejected, stopLoadingQuery)
      .addCase(updateMenuType.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(deleteMenuType.pending, startLoadingMutation)
      .addCase(deleteMenuType.fulfilled, stopLoadingMutation)
      .addCase(deleteMenuType.rejected, stopLoadingMutation);
  },
});

export const { setSelectedRows, setAppliedSearchText } = MenuTypeSlice.actions;
export default MenuTypeSlice.reducer;
